module.exports = __webpack_public_path__ + "static/img/8.1611495c.png";